import React from 'react';
import { Typography } from '@mui/material';
import { useReportConfig } from '../../contexts/ReportConfigContext.jsx';

/**
 * Componente de campo estilizado para relatórios.
 *
 * Combina:
 * - estilos padrões passados via defaultSx
 * - estilos configurados em config.styles[domainKey][fieldKey]
 */
export default function ReportStyledField({
  domainKey,
  fieldKey,
  defaultSx = {},
  children,
  variant = 'body2',
  component,
  sx,
  ...typographyProps
}) {
  const { getFieldStyle } = useReportConfig();

  // Estilo base: defaultSx + sx direto do chamador
  const baseSx = { ...(defaultSx || {}) };
  if (sx) {
    Object.assign(baseSx, sx);
  }

  const resolvedSx = getFieldStyle(domainKey, fieldKey, baseSx);

  return (
    <Typography variant={variant} component={component} sx={resolvedSx} {...typographyProps}>
      {children}
    </Typography>
  );
}
